const cssVars = require("css-vars-ponyfill")

exports.onClientEntry = () => {
  cssVars.default()
}

exports.onPreRouteUpdate = ({ location, prevLocation }) => {
  const BODY_LOCK = "util__body-lock"

  if (document.body.classList.contains(BODY_LOCK)) {
    document.body.classList.remove(BODY_LOCK)
  }
}

exports.onRouteUpdate = location => {
  if (location.location.hash) {
    setTimeout(() => {
      document.querySelector(`${location.location.hash}`).scrollIntoView()
    }, 0)
  }
}
